export default __webpack_public_path__ + "static/media/PowerGrotesk-Black.ea0419c8.otf";